module.exports = __webpack_public_path__ + "img/icons BFr_25.f20643ec.png";